module.exports = __webpack_public_path__ + "static/img/lunbo4.4e178c6f.webp";